const Blog = () => {
  return (
    <h1>This is Blog page</h1>
  );
}

export default Blog;